<template>
	<div class="man" id="man">
		<section class="man-top">
			<a class="bw-logo" href="http://www.cosmopolitan.com.tw/" target="_blank"><img src="../assets/images/bw-logo.png" alt=""></a>
			<img v-if="screenWidth>1200" src="../assets/images/man-title.png" alt="">
			<img v-else src="../assets/images/man-title-m.png" alt="">
		</section>
		<section v-if="screenWidth>1200" class="man-pd-container">
			<div class="category-conatiner" v-for="(category,index) in manProduct"  >
				<div class="category-title">
					<h1 class="category-name">{{ manCategory[index].title }} </h1>
				</div>
				<div class="pd-item pd-top1" v-bind:style="{backgroundImage: 'url(' + setImageUrl(category[1].image) + ')'}" :key="category[1].no" v-on:click="saveModalShowPd(category[1])" data-toggle="modal" data-target="#Modal">
					<div class="pd-cover">
						<h4 class="pd-brand"> {{ category[1].brand }} </h4>
						<p> {{ category[1].product }} </p>
						<div class="pd-detail">
							產品說明
						</div>
					</div>
				</div>
				<div class="pd-sm">
					<div class="pd-item pd-top2" v-bind:style="{backgroundImage: 'url(' + setImageUrl(category[2].image) + ')'}" :key="category[2].no" v-on:click="saveModalShowPd(category[2])" data-toggle="modal" data-target="#Modal">
						<div class="pd-cover">
							<h4 class="pd-brand"> {{ category[2].brand }} </h4>
							<p> {{ category[2].product }} </p>
							<div class="pd-detail">
								產品說明
							</div>
						</div>
					</div>
					<div class="pd-item pd-top3" v-bind:style="{backgroundImage: 'url(' + setImageUrl(category[3].image) + ')'}" :key="category[3].no" v-on:click="saveModalShowPd(category[3])" data-toggle="modal" data-target="#Modal">
						<div class="pd-cover">
							<h4 class="pd-brand"> {{ category[3].brand }} </h4>
							<p> {{ category[3].product }} </p>
							<div class="pd-detail">
								產品說明
							</div>
						</div>
					</div>
				</div>
				<div class="pd-item pd-star" v-bind:style="{backgroundImage: 'url(' + setImageUrl(category[4].image) + ')'}" :key="category[4].no" v-on:click="saveModalShowPd(category[4])" data-toggle="modal" data-target="#Modal">
					<div class="pd-cover">
						<h4 class="pd-brand"> {{ category[4].brand }} </h4>
						<p> {{ category[4].product }} </p>
						<div class="pd-detail">
							產品說明
						</div>
					</div>
				</div>
			</div>
		</section>
		<section v-else class="man-pd-container">
			<div class="category-conatiner" v-for="(category,index) in manProduct"  >
				<div class="category-title">
					<h1 class="category-name">{{ manCategory[index].title }} </h1>
				</div>
				<div class="pd-item pd-top1" v-bind:style="{backgroundImage: 'url(' + setImageUrl(category[1].image) + ')'}" :key="category[1].no" v-on:click="saveModalShowPd(category[1])" data-toggle="modal" data-target="#Modal">
					<div class="pd-cover">
						<h4 class="pd-brand"> {{ category[1].brand }} </h4>
						<p> {{ category[1].product }} </p>
						<div class="pd-detail">
							產品說明
						</div>
					</div>
				</div>
				<div class="pd-item pd-top2" v-bind:style="{backgroundImage: 'url(' + setImageUrl(category[2].image) + ')'}" :key="category[2].no" v-on:click="saveModalShowPd(category[2])" data-toggle="modal" data-target="#Modal">
					<div class="pd-cover">
						<h4 class="pd-brand"> {{ category[2].brand }} </h4>
						<p> {{ category[2].product }} </p>
						<div class="pd-detail">
							產品說明
						</div>
					</div>
				</div>
				<div class="pd-item pd-top3" v-bind:style="{backgroundImage: 'url(' + setImageUrl(category[3].image) + ')'}" :key="category[3].no" v-on:click="saveModalShowPd(category[3])" data-toggle="modal" data-target="#Modal">
					<div class="pd-cover">
						<h4 class="pd-brand"> {{ category[3].brand }} </h4>
						<p> {{ category[3].product }} </p>
						<div class="pd-detail">
							產品說明
						</div>
					</div>
				</div>
				<div class="pd-item pd-star" v-bind:style="{backgroundImage: 'url(' + setImageUrl(category[4].image) + ')'}" :key="category[4].no" v-on:click="saveModalShowPd(category[4])" data-toggle="modal" data-target="#Modal">
					<div class="pd-cover">
						<h4 class="pd-brand"> {{ category[4].brand }} </h4>
						<p> {{ category[4].product }} </p>
						<div class="pd-detail">
							產品說明
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="expert-man">
			<img v-if="screenWidth>1200" src="../assets/images/d-man-list.png" alt="" class="expert-man-d">
			<img v-else src="../assets/images/m-man-list.png" alt="" class="expert-man-m">
		</section>
		<Modal :modalShownSon="modalShown" :votePageShowPd="modalPd" :imgUrl="cosmoUrl" :sendPage="'man'"  ></Modal>
	</div>
</template>

<script>
import Modal from '../components/Modal'
var VueScrollTo = require('vue-scrollto')
export default{
	name: 'man',
	data(){
		return {
			modalShown: false,
			modalPd : {},
			manCategory:{
				1:{
					title: "初戀顏"
				},
				2:{
					title: "電眼殺手"
				},
				3:{
					title: "最撩人唇"
				},
				4:{
					title: "心動雙頰"
				},
				5:{
					title: "誘人香氣"
				},
				6:{
					title: "迷人髮香"
				}
			},
			manProduct:{
				1: {
					1:{
						"no": 1,
						"brand": "cle de peau Beaute 肌膚之鑰",
						"product": "裸肌光采輕妝條SPF17 PA++",
						"price": "NT. 2700",
						"capacity" : "9g",
						"image" : "m1-1.jpg",
						"detail": "輕薄如同絲柔般觸感的條狀粉底.打造出彷彿薄紗般,無瑕且充滿光澤的自然裸肌妝感。呈現妝容美麗、清透自然的美麗質感。同時兼具肌膚保養功效。"
					},
					2:{
						"no": 2,
						"brand": "SK-II",
						"product": "光感煥白cc霜 SPF 50 PA++++",
						"price": "NT.2500",
						"capacity" : "30g",
						"image" : "m1-2.jpg",
						"detail": "蘊含光體能量複方，打造無瑕鑽白光感裸肌。高效保濕防曬、輕盈的保濕成分極易被肌膚吸收，水分深入肌底，幫助肌膚持妝長達12小時，打造無瑕鑽白光感裸肌，色澤自然，能修飾斑點與瑕疵，讓肌膚呈現完美無瑕。"
					},
					3:{
						"no": 3,
						"brand": "SHISEIDO資生堂國際櫃",
						"product": "時尚色繪花椿全效氣墊粉餅",
						"price": "NT.1550 (粉蕊NT.1000、粉盒NT.450)",
						"capacity" : "12g",
						"image" : "m1-3.jpg",
						"detail": "延續尚質長效精華粉蜜內含的透明修飾聚合物與天然植物配方，展現如薄紗般的高度遮瑕力，賦予肌膚活力維持健康光澤；而新添加的超級玻尿酸與極致亮化粉末，可感應肌膚水分，依據個人肌質類型與狀態強化保濕能力，並有效控油，全日維持粧容最佳狀態，展現隨心所欲的光耀潤澤。"
					},
					4:{
						"no": 4,
						"brand": "KATE 凱婷",
						"product": "零瑕肌密粉底液 SPF18 PA++",
						"price": "NT.500",
						"capacity" : "30ml",
						"image" : "m1-4.jpg",
						"detail": "輕輕一抹即平滑延展至肌膚各處，遮飾全臉瑕疵，不易浮粉、與肌膚融為一體。徹底遮蓋毛孔、凹凸卻不感到厚重感，遮飾泛紅等膚色不均，將膚色提亮一個色階，並添加預防肌膚乾燥的保濕成份。"
					}
				},
				2: {
					1:{
						"no": 5,
						"brand": "PONY EFFECT",
						"product": "I'M MEME 我愛10色眼影盤",
						"price": "NT.950",
						"capacity" : "10g",
						"image" : "m2-1.jpg",
						"detail": "匯集各種場合適用的10款必備色彩，添加高質量精油，易顯色且持久不結塊，內含珍珠萃取物，提亮整體眼妝效果，內附實用雙頭眼影刷，滿足各種妝效。10色百變色彩同時可作為眉粉、腮紅、修容，"
					},
					2:{
						"no": 6,
						"brand": "Dior迪奧",
						"product": "一啾上癮濃密睫毛膏",
						"price": "NT.1200",
						"capacity" : "5g",
						"image" : "m2-2.jpg",
						"detail": "這款睫毛膏更有著革命性的上妝方式。只要輕壓軟管狀瓶身，即可軟化高濃度配方，讓睫毛膏滑順好上色，質地滑順的睫毛膏可完整包覆睫毛刷。輕輕一刷，立即打造不糾結的超濃密美睫！"
					},
					3:{
						"no": 7,
						"brand": "TOM FORD",
						"product": "高級訂製四格眼盤",
						"price": "NT.3100",
						"capacity" : "",
						"image" : "m2-3.jpg",
						"detail": "大量運用了不同質地、光澤與獨特的顏色組合，創造出一款款動人且獨一無二的眼盤，從閃耀的光芒、細緻動人的珠光，再到高貴優雅的霧面質地，顏色的搭配上延續他對於色彩的敏銳度，即使是四款顏色交互層疊，以能輕鬆駕馭出專屬於你的獨特時尚魅力。"
					},
					4:{
						"no": 8,
						"brand": "laura mercier蘿拉蜜思",
						"product": "夢露煙燻眼彩筆",
						"price": "NT.1,100",
						"capacity" : "64g",
						"image" : "m2-4.jpg",
						"detail": "獨創持久凝色科技，塗抹後1分鐘內可用指腹輕鬆暈染成漸層煙燻妝感，擁有絕佳抗暈防水力！輕盈乳霜質地，滑順飽和不拉扯眼皮、柔滑光感球狀粉體，360度貼合眼皮肌膚，輕鬆描繪任何眼型！"
					}
				},
				3: {
					1:{
						"no": 9,
						"brand": "Dior迪奧",
						"product": "癮誘超模染唇露",
						"price": "NT.1050",
						"capacity" : "6ml",
						"image" : "m3-1.jpg",
						"detail": "創新複合質地，一半是釉彩、一半是唇膏，革命性蛻變出高飽和、高顯色的亮澤漆光。含有高濃度飽和顯色粒子，一抹就極致飽和、極亮漆光、極美輕盈！"
					},
					2:{
						"no": 10,
						"brand": "GUERLAIN嬌蘭",
						"product": "KISSKISS法式之吻華麗絲霧唇膏",
						"price": "NT.1350",
						"capacity" : "3.5g ",
						"image" : "m3-2.jpg",
						"detail": "兼具保濕、豐唇，又呈現精緻霧感的唇膏，能使唇部豐滿、保濕、持續豐盈，妝效呈現極致優雅的絲霧感，增強保濕效果，持色效果強，鮮明飽和的唇色，猶如為雙唇穿上華麗絲絨款的高級訂製服。"
					},
					3:{
						"no": 11,
						"brand": "THE FACE SHOP 菲詩小舖",
						"product": "水波豐唇悄悄話唇露",
						"price": "NT.390",
						"capacity" : "4g ",
						"image" : "m3-3.jpg",
						"detail": "高飽和的亮面唇露，讓雙唇宛如水波般晶亮豐滿，添加高保濕精華油配方，讓唇部肌膚長時間保濕光亮；輕盈的空氣感質地能緊密服貼雙唇，使唇彩長效持久。特殊貼唇狀唇棒設計，能完全服貼唇部凹凸弧形，一筆即可完美上色。"
					},
					4:{
						"no": 12,
						"brand": "MARY KAY玫琳凱",
						"product": "氣墊霧光唇膏",
						"price": "NT.880",
						"capacity" : "3.6g ",
						"image" : "m3-4.jpg",
						"detail": "而玫琳凱企業憑藉著讓女人們全方位提升、成長的精神，打造出全新『氣墊霧光唇膏』！獨特的是，獨家研發出空氣球氣墊粒，有別過往的海棉氣墊體設計，而是利用空心球狀微分子在唇表面形成綿密彈力網包覆唇肌，創造豐盈的唇妝。！添加結葵花子油、荷荷芭油深度長效保濕滋潤，徹底解決霧面唇容易乾燥產生唇紋的問題。"
					}
				},
				4: {
					1:{
						"no": 13,
						"brand": "CLINIQUE 倩碧",
						"product": "花漾腮紅",
						"price": "NT.800",
						"capacity" : "3.5g ",
						"image" : "m4-1.jpg",
						"detail": "最新專利「慢火精緻烘焙技術(new patented slow-bake process)」，讓腮紅由液狀轉為粉狀，顏色更為持久，同時提供最純淨自然的紅潤色調，絕對顯色不脫妝。這款腮紅以腮紅刷輕刷可以呈現粉霧的繽紛感，用指腹疊擦則有絲滑乳霜的豐盈質地。它能輕鬆呈現持久的頰色，全天呈現光采無瑕的美麗肌膚。"
					},
					2:{
						"no": 14,
						"brand": "PONY EFFECT",
						"product": "PONY女王 4色漸層腮紅",
						"price": "NT.399",
						"capacity" : "3.5g ",
						"image" : "m4-2.jpg",
						"detail": "多層次的混色花卉打造暈染般的自然色彩，可打亮到陰影修飾。濕潤與絲滑的質地，增加持久性。富含低敏且自然的有機成分，不易引起肌膚敏感現象。"
					},
					3:{
						"no": 15,
						"brand": "BOBBI BROWN芭比波朗",
						"product": "晶幻頰彩蜜粉兩用餅",
						"price": "NT.1850",
						"capacity" : "6.6g ",
						"image" : "m4-3.jpg",
						"detail": "將頰彩與蜜粉完美結合，以6色的搭配重現不同風貌的星紗色彩，熱情洋溢的古銅、純粹的愛戀紅以及光彩奪目的提亮色彩，全部都在一盒顏彩盤之中，輕輕一刷即能修正膚色，散發健康、自然的光澤。"
					},
					4:{
						"no": 16,
						"brand": "伊麗莎白雅頓",
						"product": "沐光之吻粉漾金修容盤",
						"price": "NT.1,550",
						"capacity" : "",
						"image" : "m4-4.jpg",
						"detail": "結合打亮、腮紅、雕塑輪廓與修容各種功能，以深色先雕塑輪廓，再以亮色加強打亮，最後以金色修飾妝容，讓五官充滿立體光澤。"
					}
				},
				5: {
					1:{
						"no": 17,
						"brand": "GUERLAIN嬌蘭",
						"product": "小黑裙搖滾皮衣玫瑰淡香精",
						"price": "30ml NT.2550 , 50ml NT.3750",
						"capacity" : "",
						"image" : "m5-1.jpg",
						"detail": "經典倒心型瓶身全新演繹，深黑亮面外觀，猶如透亮的皮革。瓶子頸部以仿浮雕皮飾的鉚丁壓紋為亮點，完美呼應皮衣的質感，展現搖滾專屬的酷炫魅力。外觀標籤採用銀黑色調，強烈襯托黑色皮革與金屬綴飾細節。"
					},
					2:{
						"no": 18,
						"brand": "MOSCHINO",
						"product": "小粉紅‧清新女性淡香水",
						"price": "NT.1350, 50ml NT.2500",
						"capacity" : "30ml ",
						"image" : "m5-2.jpg",
						"detail": "清新女性淡香水從香味裡給你滿滿的粉紅色魅力！以玫瑰的香味為主調，幽默逗趣的瓶身設計小粉紅讓人不僅在嗅覺上視覺上也感受到MOSCHINO引爆的粉紅色氣息。"
					},
					3:{
						"no": 19,
						"brand": "NEOM",
						"product": "活力綻放香水",
						"price": "NT.2600",
						"capacity" : "49ml",
						"image" : "m5-3.jpg",
						"detail": "採用100%天然成分，揉合了葡萄柚、檸檬、迷迭香等共17種天然植物精油，與肌膚自然融合，交織迷人自信的明亮氣息，創造出鮮嫩明亮的青春氣息，在每一日需要提振的時刻，賦予你滿滿的能量及活力，適合現代人忙碌的每一天。"
					},
					4:{
						"no": 20,
						"brand": "Maison Francis Kurkdjian",
						"product": "À la rose 愛戀玫瑰淡香精",
						"price": "NT.6480",
						"capacity" : "70ml",
						"image" : "m5-4.jpg",
						"detail": "法國頂級香氛品牌Maison Francis Kurkdjian，帶給妳滿是玫瑰花香的全新淡香精體驗。以香氛傳達對愛情的宣誓，更是對女人的優雅讚頌。以250朵來自南法格拉斯的珍稀玫瑰，以及150朵保加利亞大馬士革玫瑰，在摩登典雅的香水瓶中，釋放美妙色澤和無與倫比的馥郁，喚醒妳自在雍容的優雅魅力。"
					}
				},
				6: {
					1:{
						"no": 21,
						"brand": "Amyris Femme阿米香樹之香",
						"product": "髮香噴霧",
						"price": "NT.2380",
						"capacity" : "70ml",
						"image" : "m6-1.jpg",
						"detail": "質地輕盈細緻的髮香噴霧，完全不含酒精成分，溫柔呵護每一絲秀髮。採用創新科技，萃取自天然篦麻種子與維他命原B5的保濕因子，可以快速修復毛躁髮絲，進而在表面形成一層防護膜，賦予潤澤亮麗的同時，保護秀髮免受外在環境傷害，頂級的香氛更可立刻去除頭頭異味，就像是為秀髮進行一場精緻奢華的香氛洗禮，自然散發迷人花香與亮麗光澤。"
					},
					2:{
						"no": 22,
						"brand": "Rene Furterer荷那法蕊",
						"product": "5 SENS 微金女神菁萃油",
						"price": "NT.2500",
						"capacity" : "100ml",
						"image" : "m6-2.jpg",
						"detail": "適合所有髮質與肌膚類型，不含矽靈，幫助保濕滋養頭髮與肌膚，提升光澤度，輕盈不黏手、不油膩、不會造成肌膚與頭髮的負擔，滋養肌膚頭髮同時讓粉絲保持迷人香氛魅力。"
					},
					3:{
						"no": 23,
						"brand": "海倫仙度絲",
						"product": "致美潤澤洗髮乳 (潤澤柔亮)",
						"price": "NT.219",
						"capacity" : "500ml",
						"image" : "m6-3.jpg",
						"detail": "並結合日本創新BIO頭皮養護科技，能舒緩乾燥、發癢的頭皮，改善頭皮屑現象，添加珍貴摩洛哥堅果乳、蘭花凝萃和酪梨精華，帶給你健康頭皮、柔亮秀髮雙效極致呵護。另外全新系列香氛升級，由世界級調香師調製媲美香水前中後調的雅緻香氛。"
					},
					4:{
						"no": 24,
						"brand": "Pert飛柔",
						"product": "淨油柔順微米淨透洗髮露",
						"price": "NT. 199",
						"capacity" : "530ml",
						"image" : "m6-4.jpg",
						"detail": "Micellar微米精華乳精華微粒比髮絲更細小，易均勻分布於髮絲，打造輕盈柔順的秀髮，質地輕盈，避免頭髮厚重黏膩，有效追蹤撫平毛躁，蘊含天然白茶精華與檸檬草精萃，打造蓬鬆柔順的秀髮  。"
					}
				}
			}

		}
	},
	props:{
		cosmoUrl: String,
		screenWidth: Number
	},
	components:{
		Modal
	},
	watch:{

		modalShown(value){
          let self = this 
          self.modalShown = value
	  },
	},
	created (){
		
	},
	mounted(){
		let scroll_e = VueScrollTo.scrollTo('.man')
	},
	 methods:{
		 toggleModalFlag: function(pdId){
			let self = this
			self.modalShown = !self.modalShown
			// console.log(self.modalShown)
		},
		 setImageUrl: function(productImage){
			let self = this 
			return self.cosmoUrl+'images/'+productImage
		},
		saveModalShowPd: function(pd){
			let self = this 
			self.modalPd = pd
			// console.log(pd)
			self.toggleModalFlag
		},
		searchPd: function(id){
			let self = this 
			let obj = self.manProduct
			
			// console.log(id)
			Object.keys(obj).forEach((key)=>{      
				if(obj[key].no == id)
				{
					// console.log(obj[key].no)
				}
			})   
		}
	 }
}
</script>

<style lang="sass" scoped>
$main-color: #f21290
@mixin rwd($w)
	@media only screen and (max-width: $w) 
		@content
@mixin bgcentercover
	background-repeat: no-repeat
	background-position: 50% 50%
	background-size: cover
@mixin bgcenter
	background-repeat: no-repeat
	background-position: 50% 50%
	background-size: 100%
.man 
	background-image: url(../assets/images/d-bg.jpg)
	background-position: 50% 0
	background-size: cover
	background-repeat: no-repeat
	background-attachment: fixed
	padding-bottom: 100px
.man-top 
	width: 100%
	height: 600px
	position: relative
	// overflow: hidden
	padding-top: 21px
	// background-color: #000
	z-index: 1
	padding-top: 64px
	img 
		margin: 0 auto
	&:after
		content: ''
		position: absolute
		z-index: -1
		top: 0
		left: calc(50% - 1280px)
		height: 684px
		width: 2560px
		background-image: url(../assets/images/d-page-kv.png)
		background-position: 50% 0
		background-size: cover
		background-repeat: no-repeat
	// &:before
	// 	content: ''
	// 	position: absolute
	// 	left: 0
	// 	bottom: -600px
	// 	width: 100%
	// 	height: 600px
	// 	background: linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	// 	background: -moz-linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	// 	background: -webkit-linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	// 	background: -o-linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	.bw-logo
		height: 54px
		position: absolute
		top: 21px
		left: calc(50% - 600px)
		img 
			height: 100%
.man-pd-container
	width: 100%
	// height: 800px
	margin-top: -340px
	z-index: 5
	position: relative
	
.category-conatiner
	display: flex
	flex-direction: row
	margin: 0 auto
	justify-content: space-between
	align-items: flex-end
	width: 1050px
	position: relative
	margin-bottom: 90px
	&:after 
		content: ''
		position: absolute
		bottom: -45px
		width: 1047px
		height: 2px
		background-image: linear-gradient(to right, #03001e 1%, #7303c0 10%, #ec38bc 49%, #7303c0 87%, #03001e)
	&:last-child 
		&:after
			background-image: none
.category-title
	width: 298px
	height: 392px
	background-image: url(../assets/images/category-bg.png)
	background-position: 50% 50%
	background-repeat: no-repeat
	background-size: cover
	display: flex
	justify-content: center
	align-items: center
	>.category-name
		font-size: 42.9px
		font-weight: bold
		font-style: normal
		font-stretch: normal
		line-height: 1.22
		letter-spacing: 1.1px
		text-align: center
		color: $main-color
		position: relative
		display: inline-block
		text-align: center
		&:after 
			content: ''
			position: absolute
			bottom: -15px
			width: 80%
			left: 10%
			background-color: $main-color 
			height: 1px

.pd-item
	+bgcentercover
	cursor: pointer
	background-color: #fff
	position: relative
	color: #fff 
	text-align: center
	&:hover 
		.pd-cover 
			opacity: 1
			visibility: visible
	.pd-brand,
	p,
	.pd-detail
		font-size: 18px
		font-weight: 500
		line-height: 1.55
		text-align: center
		color: #ffffff
		line-height: 1.56
	.pd-detail
		background-color: $main-color
		width: 120px
		height: 35px
		line-height: 35px
		margin: 0 auto
		margin-top: 10%
	.pd-cover 
		width: 100%
		height: 100%
		background-image: url('../assets/images/pd-cover.png')
		+bgcentercover
		position: absolute
		top: 0
		left: 0
		opacity: 0
		visibility: hidden
		transition: opacity .35s, visibility .35s, height .35s
		z-index: 3
		display: flex
		flex-direction: column
		justify-content: center
		align-items: center
		padding: 0 4%

.pd-top1
	width: 296px
	height: 292px
	position: relative
	&:after
		content: ''
		position: absolute
		background-image: url('../assets/images/man-title-top1.png')
		background-position: 50% 50%
		width: 153px
		height: 58px
		background-size: 100%
		background-repeat: no-repeat
		top: -70px
		left: calc(50% - 71.5px)
	

.pd-sm 
	$sm-size: 188px
	display: flex
	width: $sm-size
	flex-direction: column

	>.pd-top2,
	>.pd-top3
		width: $sm-size
		height: $sm-size
		position: relative
		&:after
			content: ''
			position: absolute
			bottom: 3%
			left: 3%
			width: 48px
			height: 17px
			background-size: 100%
	>.pd-top2 
		margin-bottom: 8.5px
		&:after 
			background-image: url(../assets/images/man-title-top2.png)
	>.pd-top3 
		&:after
			background-image: url(../assets/images/man-title-top3.png)
		

.pd-star
	position: relative
	width: 235px
	height: 296px
	background-color: #fff
	.pd-cover
		background-image: url(../assets/images/man-star-border.png)
	&:after 
		content: ''
		position: absolute
		background-image: url('../assets/images/man-title-star.png')
		+bgcentercover
		width: 115px
		height: 68px
		top: -70px
		left: calc(50% - 57.5px)
.expert-man
	img 
		margin: 0 auto

+rwd(1200px)
	.man-top 
		width: 100%		
		background: none
		padding: 0
		padding-top: 183px
		height: auto
		padding-bottom: 14px
		&:after 
			height: 775px
			width: 100%
			left: 0
			top: 0
			background-image: url(../assets/images/m-page-kv-n.png)
			background-position: 0% 0	
			background-size: 100%
			background-color: transparent
			background-repeat: no-repeat
		img 

		.bw-logo 
			height: auto 
			left: 35px
		.man-title 
			padding-top: 144px
			margin-bottom: 20px	
	.man-pd-container
		margin-top: 0
		height: auto
	.category-conatiner
		width: 662px
		margin: 0 auto	
		flex-wrap: wrap
		// justify-content: space-evenly
		&:after 
			width: 100%

	.category-title
		width: 96%
		margin: 0 auto	
		height: 144px	
		background-image: url(../assets/images/category-bg-m.png)
		>.category-name
			font-size: 50px
			line-height: 1.05
			letter-spacing: 1.3px
			font-weight: 500
	
	
	$pd-item: 320px
	.pd-item
		width: $pd-item
		height: $pd-item
		margin: 5px
		.pd-cover 
			opacity: 1
			visibility: visible
		
			h4,p,div
				display: none
		// &:first-chile 
		// 	margin: 0
		// &:nth-child(2)
		// 	margin: 0
	.pd-top1
		.pd-cover 
			background-image: url(../assets/images/man-title-top1-m.png)
		&:after 
			display: none

	.pd-top2 
		.pd-cover 
			background-image: url(../assets/images/man-title-top2-m.png)
			background-size: 30%
			background-position: 97% 74%
	.pd-top3 
		.pd-cover 
			background-image: url(../assets/images/man-title-top3-m.png)
			background-size: 30%
			background-position: 97% 74%
	.pd-star
		.pd-cover 
			background-image: url(../assets/images/man-title-star-m.png)
			background-size: 74%
			background-position: 100% 0
		&:after 
			display: none
	.expert-man 
		padding-top: 10%
</style>



// WEBPACK FOOTER //
// Man.vue?00401ad4